export default {
  /**
   * Sort items in ascending order
   *
   * @param {Immutable} items
   * @param {String} key
   */
  sort(items, key) {
    return items.sort((a, b) => {
      if (a.get(key) < b.get(key)) return -1;
      if (a.get(key) > b.get(key)) return 1;
      return 0;
    });
  },

  /**
   * Sort items in descending order
   *
   * @param {Immutable} items
   * @param {String} key
   */
  sortDescending(items, key) {
    return items.sort((a, b) => {
      if (a.get(key) > b.get(key)) return -1;
      if (a.get(key) < b.get(key)) return 1;
      return 0;
    });
  },
};
